import React from 'react'
import { FormattedMessage as Lang } from 'react-intl'
import ServiceIcons from '@/components/icons/serviceDeskMyCity'
import {
  RECEIVED,
  WAITING_FOR_EXECUTION,
  TASKS_PERFORMED,
  DONE,
  OVERDUE_ON_EXECUTION,
  WAITING_FOR_CONTROL,
  AVERAGE_LEAD_TIME,
  CURRENT_MONTH,
  ALL_TIME,
} from '@/constants/serviceDeskMyCity'

export const contentStructure = [
  {
    id: RECEIVED,
    icon: ServiceIcons.RegisteredIcon,
    text: <Lang id={"widgetsDashboard.registered"}/>,
    value: '',
  },
  {
    id: WAITING_FOR_EXECUTION,
    icon: ServiceIcons.WaitingExecutionIcon,
    text: <Lang id={"widgetsDashboard.waitingExecution"}/>,
    value: '',
  },
  {
    id: TASKS_PERFORMED,
    icon: ServiceIcons.InWorkIcon,
    text: <Lang id={"widgetsDashboard.work"}/>,
    value: '',
  },
  {
    id: DONE,
    icon: ServiceIcons.SolvedIcon,
    text: <Lang id={"widgetsDashboard.resolved"}/>,
    value: '',
  },
  {
    id: OVERDUE_ON_EXECUTION,
    icon: ServiceIcons.OverdueIcon,
    text: <Lang id={"widgetsDashboard.overdue"}/>,
    value: '',
  },
  {
    id: WAITING_FOR_CONTROL,
    icon: ServiceIcons.DelayedIcon,
    text: <Lang id={"widgetsDashboard.delayed"}/>,
    value: '',
  },
  {
    id: AVERAGE_LEAD_TIME,
    icon: ServiceIcons.AverageTimeDecisionIcon,
    text: <Lang id={"widgetsDashboard.executionTime"}/>,
    value: '',
  },
]

export default [
  {
    id: CURRENT_MONTH,
    title: <Lang id={"widgetsDashboard.currentMonth"}/>,
    content: contentStructure,
  },
  {
    id: ALL_TIME,
    title: <Lang id={"widgetsDashboard.wholePeriod"}/>,
    content: contentStructure,
  },
]
